export default __webpack_public_path__ + "static/media/ic-warning-blue.66f0bdf9.svg";